'use client'
import React, { useState } from 'react'
import parse from 'html-react-parser';
import tailwindConfig from '@tailwind.config'


const HtmlComponent = ({ subcategory, html, dictionary }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };
    const style2 = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 120,
        overflow: 'hidden',
        z: 10
    };

    const maxContentLength = 200; // Maximum characters to display before truncating
    const [showFullContent, setShowFullContent] = useState(false);

    const truncatedContent = html[0]?.slice(0, maxContentLength);
    const isContentTruncated = html[0]?.length > maxContentLength;

    const toggleContent = () => {
        setShowFullContent(!showFullContent);
    };

    return (
        <div className='mb-3 pb-3'>
            <h2 className='text-maincolor font-semibold text-xl mb-2'>{dictionary.aboutThis}{subcategory}</h2>
            <div /*className='text-justify'*/>
                {!showFullContent && (
                    <>
                        <div style={style2}>
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='relative w-full flex justify-center'>
                                <div className='absolute right-0 left-0 top-[-20px] h-[20px] bg-gradient-to-b from-transparent to-light'></div>
                                    <div className='mt-2 w-full flex flex-row items-center'>
                                        <div className='w-full mr-2 border-b-[1px] border-third/30'></div>
                                        <button
                                            className="w-[270px] px-4 cursor-pointer border-[1px] text-maincolor border-maincolor bg-third rounded-full hover:bg-maincolor hover:text-light"
                                            onClick={toggleContent}
                                        >
                                            {showFullContent ? `${dictionary.readLess}` : `${dictionary.readMore}`}
                                        </button>
                                        <div className='w-full ml-2 border-b-[1px] border-third/30'></div>
                                    </div>
                            </div>
                        )}
                    </>
                )}
                {showFullContent && (
                    <>
                        <div style={style}>
                            {parse(`${html}`)}
                        </div>
                        {isContentTruncated && (
                            <div className='mt-2 w-full flex flex-row items-center'>
                                <div className='w-full mr-2 border-b-[1px] border-third/30'></div>
                                {/* <br /> */}
                                <button
                                    className="w-[270px] px-4 cursor-pointer border-[1px] text-maincolor border-maincolor bg-third rounded-full hover:bg-maincolor hover:text-light"
                                    onClick={toggleContent}
                                >
                                    {showFullContent ? `${dictionary.readLess}` : `${dictionary.readMore}`}
                                </button>
                                <div className='w-full ml-2 border-b-[1px] border-third/30'></div>

                            </div>
                            
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default HtmlComponent